import React from 'react';
import bgImage from '../assets/images/bg.png';

const PhotoGallery = () => {
    return (
        <section className="w-full h-[300px] md:h-[450px] relative overflow-hidden">
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${bgImage})` }}
            />
            {/* Optional overlay for better integration with site theme */}
            <div className="absolute inset-0 bg-black/5" />
        </section>
    );
};

export default PhotoGallery;
